// Calendar right-click menu — quick actions on a booking without leaving the tape chart.
import React, { useEffect } from 'react';
import { ArrowRightLeft, Ban, LogIn, LogOut, MessageCircle, Loader2 } from 'lucide-react';

const CalendarContextMenu = ({ menu, folioStatus, busy, onAction, onClose }) => {
  useEffect(() => {
    const close = (e) => { if (e.type === 'keydown' && e.key !== 'Escape') return; onClose(); };
    window.addEventListener('mousedown', close);
    window.addEventListener('keydown', close);
    window.addEventListener('scroll', close, true);
    return () => { window.removeEventListener('mousedown', close); window.removeEventListener('keydown', close); window.removeEventListener('scroll', close, true); };
  }, [onClose]);

  if (!menu) return null;
  const { x, y, booking } = menu;
  const st = folioStatus;   // 'loading' | 'none' | 'reserved' | 'checked_in' | 'checked_out' | 'no_show'
  const canCheckIn = st === 'none' || st === 'reserved';
  const canCheckOut = st === 'checked_in';
  const items = [
    { k: 'checkin', label: 'Check in', icon: LogIn, enabled: canCheckIn, cls: 'text-emerald-700' },
    { k: 'checkout', label: 'Check out', icon: LogOut, enabled: canCheckOut, cls: 'text-sky-700' },
    { k: 'message', label: 'Message guest', icon: MessageCircle, enabled: true, cls: 'text-slate-800' },
    { k: 'move', label: 'Move room', icon: ArrowRightLeft, enabled: st !== 'checked_out' && st !== 'no_show', cls: 'text-slate-800' },
    { k: 'cancel', label: 'Cancel booking', icon: Ban, enabled: true, cls: 'text-red-600' },
  ];
  const rows = items.map((it) => (
    <button
      key={it.k}
      disabled={!it.enabled || busy}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={() => onAction(it.k, booking)}
      className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed ${it.cls}`}
      data-testid={`cal-menu-${it.k}`}
    >
      <it.icon className="w-4 h-4" /> {it.label}
    </button>
  ));
  const left = Math.min(x, window.innerWidth - 230);
  const top = Math.min(y, window.innerHeight - 260);
  return (
    <div
      className="fixed z-[70] bg-white rounded-xl shadow-2xl border w-56 py-1 overflow-hidden"
      style={{ left, top }}
      onMouseDown={(e) => e.stopPropagation()}
      data-testid="cal-context-menu"
    >
      <div className="px-3 py-2 border-b bg-slate-50">
        <p className="text-xs font-bold text-slate-900 truncate">{booking.guest_name}</p>
        <p className="text-[11px] text-slate-500 flex items-center gap-1">
          {booking.check_in} → {booking.check_out}
          {st === 'loading' ? <Loader2 className="w-3 h-3 animate-spin" /> : <span className="ml-auto uppercase tracking-wide font-semibold">{st === 'none' ? 'not arrived' : st.replace('_', ' ')}</span>}
        </p>
      </div>
      {rows}
    </div>
  );
};

export default CalendarContextMenu;
